/* Покупката с наложен платеж -> GA4 (purchase).

   Защо: прозорецът на Изпрати.БГ прави поръчката от чернова, без чекаута на Shopify, затова
   пикселът на Google не вижда покупка - в GA4 тези поръчки липсваха изцяло (12.10: #30340 и
   #30342 без purchase, #30341 с карта - с purchase). Картата отива в чекаута на черновата и там
   пикселът си праща покупката сам - нея не пипаме.
   Meta НЕ се пипа: Shopify праща Purchase за тези поръчки от сървъра (Conversions API, Events
   Manager 17.10 - 3 от 3) и с невидим за нас event_id - наша покупка би ги удвоила.

   Как: само НАБЛЮДАВАМЕ отговора на POST /apps/izpratibg/checkout/create - не го чакаме, не го
   променяме и при грешка мълчим, защото стоим на пътя на поръчката. При completionMode =
   completed пращаме purchase като приложението на Google при картата: transaction_id = номерът
   на поръчката (legacyResourceId), value = продуктите (без доставката), items с id
   shopify_ZZ_<продукт>_<вариант>. Сумата и редовете са от снимката на /cart.js - след успеха
   Изпрати.БГ изпразва количката преди пренасочването.
   Съгласие: window.gtag има само след „Приемам“ - пикселът на Google го създава тогава. Без него
   към Google не тръгва нищо.
   Изследването: OPS-LOG 18.10.2026 00:00 [ПРОУЧВАНЕ]; памет reference-pokupki-nalozhen-platezh-proslediavane. */
(function () {
  'use strict';
  var GA4 = 'G-VRJH5EKK45';
  // като target_country на приложението Google & YouTube - item_id трябва да е същият като при картата
  var DARZHAVA = 'ZZ';
  var ADRES = '/apps/izpratibg/checkout/create';
  // custom event за собствения пиксел (разширеният режим на съгласието) - без лични данни
  var SABITIE = 'bilkov_rai:pokupka_nalozhen';

  var fetchOrig = window.fetch;
  if (typeof fetchOrig !== 'function') return;

  var kolichka = null;

  function snimaiKolichkata() {
    try {
      return fetchOrig.call(window, '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (k) {
          if (k && k.items && k.items.length) kolichka = k;
          return kolichka;
        })
        .catch(function () { return kolichka; });
    } catch (e) {
      return Promise.resolve(kolichka);
    }
  }

  // снимка при всяко отваряне на прозореца - събитието е на Изпрати.БГ (emitPopupOpenAnalytics)
  window.addEventListener('octava:precheckout_popup_opened', function () { snimaiKolichkata(); });

  function veche(id) {
    try { return sessionStorage.getItem('br_ga4_nalozhen_' + id) === '1'; } catch (e) { return false; }
  }
  function zapomni(id) {
    try { sessionStorage.setItem('br_ga4_nalozhen_' + id, '1'); } catch (e) { /* без памет - пак пращаме веднъж на тази страница */ }
  }

  function chisla(v) {
    var n = Number(v);
    return isFinite(n) ? n : null;
  }

  function artikuli(k) {
    return ((k && k.items) || []).map(function (r) {
      var a = {
        item_id: 'shopify_' + DARZHAVA + '_' + r.product_id + '_' + r.variant_id,
        item_name: r.product_title,
        price: chisla(r.price) !== null ? r.price / 100 : undefined,
        quantity: r.quantity
      };
      if (r.vendor) a.item_brand = r.vendor;
      if (r.product_type) a.item_category = r.product_type;
      if (r.variant_title) a.item_variant = r.variant_title;
      return a;
    });
  }

  // Google иска телефона във вид E.164; в прозореца се пише и „0888…“, и „359888…“
  function telefon(v) {
    var s = String(v || '').replace(/[^\d+]/g, '');
    if (!s) return '';
    if (s.charAt(0) === '+') return s;
    if (s.indexOf('00') === 0) return '+' + s.slice(2);
    if (s.indexOf('359') === 0) return '+' + s;
    if (s.charAt(0) === '0') return '+359' + s.slice(1);
    return s;
  }

  // данните на купувача - за user_data, както приложението на Google при картата (gtag ги хешира)
  function kupuvach(t) {
    if (!t) return null;
    var adr = t.shippingAddress || {};
    var u = {};
    if (t.email) u.email = String(t.email).trim().toLowerCase();
    var tel = telefon(t.phone);
    if (tel) u.phone_number = tel;
    var a = {};
    if (adr.firstName || adr.first_name) a.first_name = adr.firstName || adr.first_name;
    if (adr.lastName || adr.last_name) a.last_name = adr.lastName || adr.last_name;
    if (adr.address1) a.street = adr.address1;
    if (adr.city) a.city = adr.city;
    if (adr.zip) a.postal_code = adr.zip;
    if (adr.country || adr.countryCode) a.country = adr.country || adr.countryCode;
    if (Object.keys(a).length) u.address = a;
    return Object.keys(u).length ? u : null;
  }

  function prati(id, t, k) {
    var ot = t && t.orderTotals;
    var stoinost = ot && chisla(ot.total_price) !== null ? ot.total_price / 100
      : (k && chisla(k.total_price) !== null ? k.total_price / 100 : undefined);
    var valuta = (ot && ot.currency) || (k && k.currency) || 'EUR';
    var danni = { transaction_id: id, value: stoinost, currency: valuta, items: artikuli(k) };

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(SABITIE, danni);
      }
    } catch (e) { /* няма абонат - нищо */ }

    if (typeof window.gtag !== 'function') return; // без съгласие пикселът на Google не е създал gtag
    var param = {
      send_to: GA4,
      transaction_id: danni.transaction_id,
      value: danni.value,
      currency: danni.currency,
      items: danni.items,
      affiliation: location.origin
    };
    var u = kupuvach(t);
    if (u) param.user_data = u;
    window.gtag('event', 'purchase', param);
    zapomni(id);
  }

  function obraboti(json, t, snimka) {
    var d = json && json.data;
    if (!d || String(d.completionMode) !== 'completed') return; // картата - пикселът в чекаута
    var id = String(d.legacyResourceId || '').trim() || String(d.orderId || '').split('/').pop();
    if (!id || veche(id)) return;
    // след отговора Изпрати.БГ изпразва количката и пренасочва - чакаме снимката най-много 400 ms
    if (kolichka) { prati(id, t, kolichka); return; }
    var gotovo = false;
    var zakasnenie = setTimeout(function () { if (!gotovo) { gotovo = true; prati(id, t, kolichka); } }, 400);
    Promise.resolve(snimka).then(function (k) {
      if (gotovo) return;
      gotovo = true;
      clearTimeout(zakasnenie);
      prati(id, t, k || kolichka);
    });
  }

  window.fetch = function (vhod, nastroiki) {
    var obeshtanie = fetchOrig.apply(window, arguments);
    try {
      var adres = typeof vhod === 'string' ? vhod : (vhod && vhod.url) || '';
      var metod = String((nastroiki && nastroiki.method) || (vhod && vhod.method) || 'GET').toUpperCase();
      if (metod === 'POST' && adres.indexOf(ADRES) !== -1) {
        var t = null;
        try { t = nastroiki && typeof nastroiki.body === 'string' ? JSON.parse(nastroiki.body) : null; } catch (e) { t = null; }
        var snimka = snimaiKolichkata();
        obeshtanie.then(function (otgovor) {
          if (!otgovor || !otgovor.ok) return;
          otgovor.clone().json().then(function (json) { obraboti(json, t, snimka); }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) { /* наблюдението никога не спира поръчката */ }
    return obeshtanie;
  };
})();
